export const alwaysTrue = () => true;
export const alwaysFalse = () => false;
